import flatten from 'flat';
import workspace from './fr-FR/workspace';

export default flatten({
  ...workspace,
});
